import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import QuickNav from "./components/QuickNav";
import EntrySection from "./components/EntrySection";
import CategorySection from "./components/CategorySection";
import GuideSection from "./components/GuideSection";
import PublishSection from "./components/PublishSection";
import NoteSection from "./components/NoteSection";
import FaqSection from "./components/FaqSection";
import DisclaimerSection from "./components/DisclaimerSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <Hero />
        <QuickNav />
        <EntrySection />
        <CategorySection />
        <GuideSection />
        <PublishSection />
        <NoteSection />
        <FaqSection />
        <DisclaimerSection />
      </main>
      <SiteFooter />
    </div>
  );
}